import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

/**
 * Master item General Service untuk sub-jenis Wooden / Drill / Others di form
 * Quotation.
 *
 * Menggantikan konstanta hardcode `wooden`, `drill`, `others` di
 * features/operasional/quatation/constants/activityOptions.js, mengikuti pola
 * master Port Service (portServiceSlice.js).
 *
 * `value` memakai "Kode", bukan ID: QoLine menyimpan salinan teks di "ItemName"
 * tanpa foreign key. `minBySubType` sudah dipilah per sub-jenis supaya form tak
 * perlu menyaring ulang di setiap baris.
 */
export const getMinGeneralServiceItem = createAsyncThunk(
  "GeneralServiceItem/getMin",
  async (_arg, thunkAPI) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "Master/GeneralServiceItem/getMin",
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        const bySubType = { WOODEN: [], DRILL: [], OTHERS: [] };
        (response.data.data ?? []).forEach((item) => {
          (bySubType[item.SubType] ??= []).push({ value: item.Kode, label: item.Nama });
        });
        return { data: bySubType };
      }
      return thunkAPI.rejectWithValue(response.data);
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data ?? { message: e.message });
    }
  }
);

const initialState = {
  message: "",
  minBySubType: { WOODEN: [], DRILL: [], OTHERS: [] },
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  errorMessage: "",
};

export const generalServiceItemSlice = createSlice({
  name: "generalServiceItem",
  initialState,
  reducers: {},
  extraReducers: {
    [getMinGeneralServiceItem.pending]: (state) => {
      state.isMinFetching = true;
      return state;
    },
    [getMinGeneralServiceItem.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minBySubType = payload.data;
      return state;
    },
    [getMinGeneralServiceItem.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload?.message ?? "Gagal memuat master item General Service";
      return state;
    },
  },
});

export const generalServiceItemSelector = (state) => state.generalServiceItem;
